import React from "react";
import Footer_m from '../footer/Footer.js';
import Header_m from '../header/Header.js';
import BaseTamplate from "../Template/Template.js";
// .................................................

import remodel from'../../img/remodel/remodel.jpg';
import remodel1 from'../../img/remodel/remodel1.jpg'; // The Weird looking one
import remodel2 from'../../img/remodel/remodel2.jpg';
// import remodel3 from'../../img/remodel/remodel3.jpg';
import remodel3 from'../../img/ourwork/fence.jpg';

// import remodel4 from '../../img/remodel/remodel4.jpg';
import remodel4 from '../../img/ourwork/driveway1.jpg';
import Grass from'../../img/remodel/remodel3.jpg';

// import Grass from '../../img/grass1.jpg';
import remodel5 from '../../img/ourwork/concrete1.jpg';


let pictureArray = [remodel1,remodel2, remodel, remodel3, remodel4,remodel5, Grass];
let whatWeDo = ['Driveways', "Porch", "Patios", "Constructions","Renovation" ];

const Remodel=() =>{
    return(
        <div>
            {/* <Header_m></Header_m> */}

            <div className="container">

            <BaseTamplate pageName ="Our Work" pictures = {pictureArray} Title="Our Work" itemList={whatWeDo}>
               {Grass}
            </BaseTamplate>

     

            </div>

            <Footer_m></Footer_m>
        </div>
    )

}

export default Remodel;
